import React, { useState, useRef, useEffect } from "react";
import { motion } from "framer-motion";
import { X, Send, Loader2, Sparkles } from "lucide-react";
import { clientApi } from "../lib/api";

export default function HectorBot({ onClose }) {
  const [messages, setMessages] = useState([
    { role: "assistant", text: "Olá! Eu sou o Hector, seu assistente Places. Posso ajudar com dúvidas sobre seus projetos, campanhas, marketing imobiliário ou o próprio mercado. Como posso te ajudar hoje?" },
  ]);
  const [input, setInput] = useState("");
  const [busy, setBusy] = useState(false);
  const [sessionId, setSessionId] = useState(null);
  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [messages]);

  const send = async () => {
    if (!input.trim() || busy) return;
    const userMsg = input.trim();
    setMessages((m) => [...m, { role: "user", text: userMsg }]);
    setInput("");
    setBusy(true);
    try {
      const { data } = await clientApi.post("/hector", { message: userMsg, session_id: sessionId });
      setSessionId(data.session_id);
      setMessages((m) => [...m, { role: "assistant", text: data.reply }]);
    } catch (e) {
      setMessages((m) => [...m, { role: "assistant", text: "Ops, tive um problema. Tente novamente." }]);
    } finally {
      setBusy(false);
    }
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 40, scale: 0.95 }} animate={{ opacity: 1, y: 0, scale: 1 }} exit={{ opacity: 0, y: 40, scale: 0.95 }}
      className="fixed bottom-24 right-6 z-50 w-[min(400px,calc(100vw-3rem))] h-[min(600px,80vh)] bg-[#0e0e0e] border border-white/10 rounded-2xl flex flex-col shadow-2xl overflow-hidden"
      data-testid="hector-bot"
    >
      <div className="p-4 border-b border-white/10 flex items-center gap-3 bg-gradient-to-r from-accent-orange/20 to-accent-yellow/10">
        <div className="w-10 h-10 rounded-full bg-gradient-to-br from-accent-orange to-accent-yellow flex items-center justify-center">
          <Sparkles className="w-5 h-5 text-black" />
        </div>
        <div className="flex-1">
          <div className="font-display text-lg leading-none">Hector</div>
          <div className="text-[10px] text-neutral-400 mt-0.5">Assistente Places · IA</div>
        </div>
        <button onClick={onClose} data-testid="hector-close" className="p-2 hover:bg-white/10 rounded-full"><X className="w-4 h-4" /></button>
      </div>

      <div ref={scrollRef} className="flex-1 overflow-y-auto p-4 space-y-3 no-scrollbar" data-testid="hector-messages">
        {messages.map((m, i) => (
          <div key={i} className={`flex ${m.role === "user" ? "justify-end" : "justify-start"}`}>
            <div className={`max-w-[85%] rounded-2xl px-4 py-2.5 text-sm leading-relaxed ${m.role === "user" ? "bg-accent-orange text-black rounded-br-sm" : "bg-white/5 text-white rounded-bl-sm"}`}>
              {m.text.split("\n").map((line, k) => <div key={k}>{line || "\u00a0"}</div>)}
            </div>
          </div>
        ))}
        {busy && (
          <div className="flex justify-start">
            <div className="bg-white/5 rounded-2xl rounded-bl-sm px-4 py-2.5 text-sm text-neutral-400 flex items-center gap-2">
              <Loader2 className="w-3 h-3 animate-spin" /> pensando…
            </div>
          </div>
        )}
      </div>

      <div className="p-3 border-t border-white/10">
        <div className="flex gap-2">
          <input
            value={input} onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => e.key === "Enter" && !e.shiftKey && send()}
            placeholder="Pergunte ao Hector…"
            data-testid="hector-input"
            className="flex-1 bg-black border border-white/10 rounded-full px-4 py-2.5 text-sm focus:border-accent-orange focus:outline-none"
          />
          <button onClick={send} disabled={busy} data-testid="hector-send" className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-orange text-black hover:bg-accent-yellow disabled:opacity-50 transition-colors">
            <Send className="w-4 h-4" />
          </button>
        </div>
      </div>
    </motion.div>
  );
}
